import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { AccessFailure, AuthService } from './auth.service';
import { MngIconComponent } from './shared/icon/icon.component';

export type NoAccessReason = AccessFailure | 'not-staff';

const COPY = {
  'not-staff': {
    heading: 'This tool is for United Portraits staff',
    body: 'Your account can sign in to Yearbook Master but is not a staff account.',
  },
  'not-provisioned': {
    heading: 'Your account is not set up for Canvas Builder',
    body: 'Sign-in worked, but Canvas Builder has no record of this account. Ask a United Portraits administrator to set it up.',
  },
  unavailable: {
    heading: 'Canvas Builder could not load your account',
    body: 'Sign-in or the Canvas Builder service did not answer. Reload the page to try again.',
  },
  'signed-out': {
    heading: 'You are signed out of Canvas Builder',
    body: 'Signing in again uses your Yearbook Master account. To switch accounts, sign out of Yearbook Master first.',
  },
} satisfies Record<NoAccessReason, { heading: string; body: string }>;

@Component({
  selector: 'mng-no-access',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.scss',
  imports: [MngIconComponent],
  host: { class: 'mng-forms' },
})
export class NoAccessComponent {
  readonly reason = input.required<NoAccessReason>();
  protected readonly auth = inject(AuthService);
  protected readonly copy = computed(() => COPY[this.reason()]);

  protected reload(): void {
    location.reload();
  }
}
